(function () {
  const root = document.getElementById("pk-special-order");
  if (!root) return;

  const API_BASE = (root.dataset.apiBase || "").replace(/\/$/, "");
  let requestId = null;
  let requestToken = null;
  let selectedCardRef = null;
  let allOffers = [];
  let activeGradeFilter = "ALL";
  let confirmingCard = false;
  let loadingMoreOffers = false;
  let partialCandidateResults = false;
  let partialOfferResults = false;
  let hasMoreOffers = false;
  let shopifyCheckoutEnabled = true;
  const $ = (sel) => root.querySelector(sel);

  const GRADE_FILTER_ORDER = [
    "ALL",
    "PSA10",
    "PSA9",
    "PSA8",
    "PSA8以下",
    "A",
    "B",
    "C",
    "D",
    "ARS10",
    "ARS9",
    "BGS10",
    "新品",
    "OTHER",
  ];

  const SEALED_KIND_LABELS = {
    booster_pack: "1 booster",
    booster_box: "Boîte scellée",
    display: "Display",
    deck: "Deck",
    other: "Scellé",
  };

  const GRADE_FILTER_LABELS = {
    ALL: "Tous",
    PSA10: "PSA 10",
    PSA9: "PSA 9",
    PSA8: "PSA 8",
    "PSA8以下": "PSA 8 et moins",
    A: "Grade A",
    B: "Grade B",
    C: "Grade C",
    D: "Grade D",
    ARS10: "ARS 10",
    ARS9: "ARS 9",
    BGS10: "BGS 10",
    新品: "Neuf",
    OTHER: "Autre",
  };

  const lightbox = document.querySelector("[data-lightbox]");
  const lightboxImg = lightbox?.querySelector("[data-lightbox-img]");
  const lightboxCaption = lightbox?.querySelector("[data-lightbox-caption]");
  const lightboxViewport = lightbox?.querySelector("[data-lightbox-viewport]");
  const lightboxCounter = lightbox?.querySelector("[data-lightbox-counter]");
  const lightboxThumbs = lightbox?.querySelector("[data-lightbox-thumbs]");
  const lightboxPrev = lightbox?.querySelector("[data-lightbox-prev]");
  const lightboxNext = lightbox?.querySelector("[data-lightbox-next]");
  const zoomLabel = lightbox?.querySelector("[data-zoom-label]");
  let lightboxScale = 1;
  let galleryUrls = [];
  let galleryIndex = 0;
  let galleryTitle = "";
  const ZOOM_MIN = 1;
  const ZOOM_MAX = 3;
  const ZOOM_STEP = 0.25;

  const STEPS = ["search", "candidates", "offers", "checkout"];
  const stepIndex = (name) => STEPS.indexOf(name);

  function updateStepper(activeStep) {
    const idx = stepIndex(activeStep);
    root.querySelectorAll("[data-stepper-item]").forEach((el) => {
      const i = stepIndex(el.dataset.stepperItem);
      el.classList.toggle("is-active", i === idx);
      el.classList.toggle("is-done", i >= 0 && i < idx);
    });
  }

  function showStep(name) {
    root.querySelectorAll("[data-step]").forEach((el) => {
      el.hidden = el.dataset.step !== name;
    });
    updateStepper(name);
    const discover = $("[data-discover]");
    if (discover) {
      discover.hidden =
        name !== "search" || root.dataset.discoverEnabled === "false";
    }
    const formWrap = root.querySelector(".pk-special-order__form-wrap");
    if (formWrap && name !== "search") {
      formWrap.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  let activeDiscoverFilter = "all";

  function productThumbHtml(imgUrl, alt, title, fallbackUrl) {
    const src = String(imgUrl || "").trim();
    const fallback = String(fallbackUrl || "").trim();
    if (!src && !fallback) {
      return `<figure class="pk-special-order__thumb pk-special-order__thumb--empty" aria-hidden="true">
        <div class="pk-special-order__thumb-btn pk-special-order__thumb-btn--placeholder">Pas de photo</div>
      </figure>`;
    }
    const displaySrc = src || fallback;
    const safeSrc = escapeHtml(displaySrc);
    const safeFallback = fallback && fallback !== displaySrc ? escapeHtml(fallback) : "";
    const safeAlt = escapeHtml(alt || "Photo produit");
    const safeTitle = escapeHtml(title || alt || "Photo produit");
    const onerr = safeFallback
      ? ` onerror="if(this.dataset.fallback){this.src=this.dataset.fallback;this.dataset.fallback=''}" data-fallback="${safeFallback}"`
      : ` onerror="this.closest('.pk-special-order__thumb-btn')?.classList.add('is-broken')"`;
    return `<figure class="pk-special-order__thumb">
      <button type="button" class="pk-special-order__thumb-btn" data-zoom-open data-zoom-src="${safeSrc}" data-zoom-alt="${safeAlt}" data-zoom-title="${safeTitle}" aria-label="Agrandir : ${safeTitle}">
        <img src="${safeSrc}" alt="${safeAlt}" loading="lazy" width="140" height="196"${onerr}/>
      </button>
      <span class="pk-special-order__thumb-hint">Agrandir la photo</span>
    </figure>`;
  }

  function applyLightboxZoom() {
    if (!lightboxImg) return;
    lightboxImg.style.transform = `scale(${lightboxScale})`;
    if (zoomLabel) zoomLabel.textContent = `${Math.round(lightboxScale * 100)} %`;
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lightbox.setAttribute("aria-hidden", "true");
    document.body.classList.remove("pk-so-lightbox-open");
    lightboxScale = 1;
    applyLightboxZoom();
    if (lightboxImg) lightboxImg.src = "";
  }

  function normalizeImageUrls(offer, fallback) {
    const raw = Array.isArray(offer?.imageUrls) ? offer.imageUrls : [];
    const list = raw.filter((u) => typeof u === "string" && u.trim());
    if (list.length) return [...new Set(list)];
    const one = offer?.imageUrl || fallback;
    return one ? [String(one)] : [];
  }

  function offerPhotosHtml(images, title) {
    if (!images.length) {
      return `<div class="pk-special-order__photos pk-special-order__photos--empty">Pas de photo</div>`;
    }
    const safeTitle = escapeHtml(title);
    const json = escapeHtml(JSON.stringify(images));
    const thumbs =
      images.length > 1
        ? `<div class="pk-special-order__photos-thumbs" role="list">${images
            .map(
              (url, i) =>
                `<button type="button" class="pk-special-order__photo-thumb${i === 0 ? " is-active" : ""}" data-photo-pick data-photo-index="${i}" aria-label="Photo ${i + 1}">
            <img src="${escapeHtml(url)}" alt="" loading="lazy" width="64" height="90"/>
          </button>`,
            )
            .join("")}</div>`
        : "";
    return `
      <div class="pk-special-order__photos" data-offer-photos data-images="${json}" data-active-index="0" data-zoom-title="${safeTitle}">
        <div class="pk-special-order__photos-main">
          <button type="button" class="pk-special-order__photos-main-btn" data-zoom-main aria-label="Voir en grand : ${safeTitle}">
            <img src="${escapeHtml(images[0])}" alt="${safeTitle}" loading="lazy" data-offer-main-img/>
          </button>
          <span class="pk-special-order__photo-count">${images.length} photo${images.length > 1 ? "s" : ""} · clic pour zoomer</span>
        </div>
        ${thumbs}
      </div>`;
  }

  function setOfferMainPhoto(wrap, urls, index) {
    if (!wrap || !urls[index]) return;
    wrap.dataset.activeIndex = String(index);
    const main = wrap.querySelector("[data-offer-main-img]");
    if (main) main.src = urls[index];
    wrap.querySelectorAll("[data-photo-pick]").forEach((btn) => {
      btn.classList.toggle(
        "is-active",
        parseInt(btn.dataset.photoIndex, 10) === index,
      );
    });
  }

  function renderLightboxGalleryUi() {
    const multi = galleryUrls.length > 1;
    if (lightboxPrev) lightboxPrev.hidden = !multi;
    if (lightboxNext) lightboxNext.hidden = !multi;
    if (lightboxCounter) {
      lightboxCounter.hidden = !multi;
      lightboxCounter.textContent = multi
        ? `Photo ${galleryIndex + 1} / ${galleryUrls.length}`
        : "";
    }
    if (!lightboxThumbs) return;
    if (!multi) {
      lightboxThumbs.hidden = true;
      lightboxThumbs.innerHTML = "";
      return;
    }
    lightboxThumbs.hidden = false;
    lightboxThumbs.innerHTML = galleryUrls
      .map(
        (url, i) =>
          `<button type="button" class="pk-so-lightbox__thumb${i === galleryIndex ? " is-active" : ""}" data-lightbox-thumb="${i}">
        <img src="${escapeHtml(url)}" alt="" loading="lazy"/>
      </button>`,
      )
      .join("");
    lightboxThumbs.querySelectorAll("[data-lightbox-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        galleryIndex = parseInt(btn.dataset.lightboxThumb, 10) || 0;
        showLightboxSlide();
      });
    });
  }

  function showLightboxSlide() {
    if (!lightbox || !lightboxImg) return;
    const src = galleryUrls[galleryIndex];
    if (!src) return;
    lightboxScale = 1;
    lightbox.classList.add("is-loading");
    lightboxImg.onload = () => lightbox.classList.remove("is-loading");
    lightboxImg.onerror = () => {
      lightbox.classList.remove("is-loading");
      if (lightboxCaption) lightboxCaption.textContent = "Image indisponible";
    };
    lightboxImg.src = src;
    lightboxImg.alt = galleryTitle || "Photo produit";
    if (lightboxCaption) lightboxCaption.textContent = galleryTitle;
    applyLightboxZoom();
    renderLightboxGalleryUi();
    if (lightboxViewport) {
      lightboxViewport.scrollTop = 0;
      lightboxViewport.scrollLeft = 0;
    }
  }

  function openLightbox(src, alt, title) {
    galleryUrls = src ? [src] : [];
    galleryIndex = 0;
    galleryTitle = title || alt || "Photo produit";
    if (!galleryUrls.length) return;
    lightbox.hidden = false;
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("pk-so-lightbox-open");
    showLightboxSlide();
    lightbox.querySelector("[data-lightbox-close]")?.focus();
  }

  function openLightboxGallery(urls, index, title) {
    galleryUrls = (urls || []).filter(Boolean);
    if (!galleryUrls.length) return;
    galleryIndex = Math.max(0, Math.min(index, galleryUrls.length - 1));
    galleryTitle = title || "Photo produit";
    lightbox.hidden = false;
    lightbox.setAttribute("aria-hidden", "false");
    document.body.classList.add("pk-so-lightbox-open");
    showLightboxSlide();
    lightbox.querySelector("[data-lightbox-close]")?.focus();
  }

  function galleryStep(delta) {
    if (galleryUrls.length < 2) return;
    galleryIndex = (galleryIndex + delta + galleryUrls.length) % galleryUrls.length;
    showLightboxSlide();
  }

  function bindZoomTriggers(scope) {
    (scope || root).querySelectorAll("[data-zoom-open]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(
          btn.dataset.zoomSrc,
          btn.dataset.zoomAlt,
          btn.dataset.zoomTitle,
        );
      });
    });
  }

  function bindOfferPhotoControls(li) {
    const wrap = li.querySelector("[data-offer-photos]");
    if (!wrap) return;
    let urls = [];
    try {
      urls = JSON.parse(wrap.dataset.images || "[]");
    } catch {
      urls = [];
    }
    const title = wrap.dataset.zoomTitle || "Photo annonce";

    wrap.querySelectorAll("[data-photo-pick]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const idx = parseInt(btn.dataset.photoIndex, 10) || 0;
        setOfferMainPhoto(wrap, urls, idx);
      });
    });

    wrap.querySelector("[data-zoom-main]")?.addEventListener("click", (e) => {
      e.stopPropagation();
      const idx = parseInt(wrap.dataset.activeIndex || "0", 10) || 0;
      if (urls.length) openLightboxGallery(urls, idx, title);
    });
  }

  function initLightbox() {
    if (!lightbox) return;
    lightbox.querySelectorAll("[data-lightbox-close]").forEach((el) => {
      el.addEventListener("click", closeLightbox);
    });
    // Secours : clic hors du dialogue (backdrop ou conteneur) ferme la modale
    lightbox.addEventListener("click", (e) => {
      if (!e.target.closest(".pk-so-lightbox__dialog")) closeLightbox();
    });
    lightboxPrev?.addEventListener("click", () => galleryStep(-1));
    lightboxNext?.addEventListener("click", () => galleryStep(1));
    lightbox.querySelector("[data-zoom-in]")?.addEventListener("click", () => {
      lightboxScale = Math.min(ZOOM_MAX, lightboxScale + ZOOM_STEP);
      applyLightboxZoom();
    });
    lightbox.querySelector("[data-zoom-out]")?.addEventListener("click", () => {
      lightboxScale = Math.max(ZOOM_MIN, lightboxScale - ZOOM_STEP);
      applyLightboxZoom();
    });
    lightbox.querySelector("[data-zoom-reset]")?.addEventListener("click", () => {
      lightboxScale = 1;
      applyLightboxZoom();
      if (lightboxViewport) {
        lightboxViewport.scrollTop = 0;
        lightboxViewport.scrollLeft = 0;
      }
    });
    document.addEventListener("keydown", (e) => {
      if (lightbox.hidden) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") galleryStep(-1);
      if (e.key === "ArrowRight") galleryStep(1);
      if (e.key === "+" || e.key === "=") {
        lightboxScale = Math.min(ZOOM_MAX, lightboxScale + ZOOM_STEP);
        applyLightboxZoom();
      }
      if (e.key === "-") {
        lightboxScale = Math.max(ZOOM_MIN, lightboxScale - ZOOM_STEP);
        applyLightboxZoom();
      }
    });
    lightboxViewport?.addEventListener(
      "wheel",
      (e) => {
        if (lightbox.hidden) return;
        e.preventDefault();
        const delta = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
        lightboxScale = Math.min(
          ZOOM_MAX,
          Math.max(ZOOM_MIN, lightboxScale + delta),
        );
        applyLightboxZoom();
      },
      { passive: false },
    );
  }

  function showError(msg) {
    const el = $("[data-error]");
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function apiNetworkErrorHint() {
    if (!API_BASE) {
      return "URL API non configurée dans la section Shopify (réglage « URL API sourcing »).";
    }
    return (
      "Connexion à l’API impossible (réseau, CORS ou serveur). " +
      "Vérifiez l’URL : " +
      API_BASE +
      " — puis redéployez l’API (git pull + pm2 restart)."
    );
  }

  async function api(path, options = {}) {
    let res;
    try {
      res = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(options.headers || {}),
        },
      });
    } catch {
      throw new Error(apiNetworkErrorHint());
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) {
      if (res.status === 401) {
        throw new Error(
          "L’API refuse la connexion (401). Sur le VPS : git pull, npm run build, pm2 restart taskmaster — les routes /api/special-orders doivent être publiques.",
        );
      }
      if (res.status === 503) {
        throw new Error(
          data.message ||
            "Service commande spéciale désactivé (FEATURE_SPECIAL_ORDER=true requis sur le serveur).",
        );
      }
      const hint = data.message || `Erreur HTTP ${res.status}`;
      throw new Error(hint);
    }
    return data;
  }

  async function compressImageForUpload(file, maxBytes = 1_400_000) {
    if (!file.type?.startsWith("image/")) {
      throw new Error("Fichier image invalide.");
    }
    const bitmap = await createImageBitmap(file);
    let w = bitmap.width;
    let h = bitmap.height;
    const maxDim = 1600;
    if (w > maxDim || h > maxDim) {
      const ratio = Math.min(maxDim / w, maxDim / h);
      w = Math.round(w * ratio);
      h = Math.round(h * ratio);
    }
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Impossible de traiter l’image.");
    ctx.drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();

    let quality = 0.88;
    let blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", quality),
    );
    while (blob && blob.size > maxBytes && quality > 0.45) {
      quality -= 0.08;
      blob = await new Promise((resolve) =>
        canvas.toBlob(resolve, "image/jpeg", quality),
      );
    }
    if (!blob) throw new Error("Impossible de compresser l’image.");
    const name = (file.name || "photo").replace(/\.[^.]+$/, "") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  }

  function readImageAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        if (typeof result !== "string" || !result.includes(",")) {
          reject(new Error("Impossible de lire l’image."));
          return;
        }
        resolve({
          base64: result.split(",")[1],
          mime: file.type || "image/jpeg",
        });
      };
      reader.onerror = () => reject(new Error("Impossible de lire l’image."));
      reader.readAsDataURL(file);
    });
  }

  const notFoundForm = $("[data-card-not-found-form]");
  const candidatesMain = $("[data-candidates-main]");
  const notFoundSuccess = $("[data-not-found-success]");
  const candidatesBack = $("[data-candidates-back]");
  let nfImagePreviewUrl = null;

  function getSearchFieldValues() {
    const searchForm = $("[data-search-form]");
    if (!searchForm) return {};
    return {
      setCode: String(searchForm.querySelector('[name="setCode"]')?.value || "").trim(),
      cardNumber: String(searchForm.querySelector('[name="cardNumber"]')?.value || "").trim(),
      title: String(searchForm.querySelector('[name="title"]')?.value || "").trim(),
      language: String(searchForm.querySelector('[name="language"]')?.value || "JP").trim(),
    };
  }

  function prefillNotFoundForm(reason = "no_match") {
    if (!notFoundForm) return;
    const ref = selectedCardRef || getSearchFieldValues();
    const setEl = notFoundForm.querySelector('[name="nfSetCode"]');
    const numEl = notFoundForm.querySelector('[name="nfCardNumber"]');
    const titleEl = notFoundForm.querySelector('[name="nfTitle"]');
    const langEl = notFoundForm.querySelector('[name="nfLanguage"]');
    if (setEl) setEl.value = ref.setCode || "";
    if (numEl) numEl.value = ref.cardNumber || "";
    if (titleEl) {
      titleEl.value =
        ref.titleFR || ref.titleJP || ref.title || titleEl.value || "";
    }
    if (langEl) langEl.value = ref.language === "FR" ? "FR" : "JP";

    const emailEl = notFoundForm.querySelector('[name="nfCustomerEmail"]');
    if (emailEl && !emailEl.value && window.Shopify?.customer?.email) {
      emailEl.value = window.Shopify.customer.email;
    }
    const nameEl = notFoundForm.querySelector('[name="nfCustomerName"]');
    if (nameEl && !nameEl.value) {
      const c = window.Shopify?.customer;
      const full = [c?.first_name, c?.last_name].filter(Boolean).join(" ").trim();
      if (full) nameEl.value = full;
    }

    const reasonEl = notFoundForm.querySelector("[data-nf-reason]");
    if (reasonEl) reasonEl.value = reason;

    syncNotFoundGradeField();
  }

  function syncNotFoundGradeField() {
    const gradeWrap = $("[data-nf-grade-field]");
    if (!gradeWrap || !notFoundForm) return;
    const productType =
      notFoundForm.querySelector('[name="nfProductType"]:checked')?.value || "";
    const show = productType === "graded";
    gradeWrap.hidden = !show;
  }

  function setNotFoundFormVisible(show, reason = "no_match") {
    if (!notFoundForm) return;
    if (show) {
      prefillNotFoundForm(reason);
      notFoundForm.hidden = false;
      if (candidatesMain) candidatesMain.hidden = true;
      if (candidatesBack) candidatesBack.hidden = true;
      if (notFoundSuccess) notFoundSuccess.hidden = true;
      const hint = $("[data-candidates-hint]");
      if (hint) hint.hidden = true;
    } else {
      notFoundForm.hidden = true;
      if (candidatesMain) candidatesMain.hidden = false;
      if (candidatesBack) candidatesBack.hidden = false;
      if (notFoundSuccess) notFoundSuccess.hidden = true;
      const hint = $("[data-candidates-hint]");
      if (hint) hint.hidden = false;
    }
    showError("");
  }

  function showNotFoundSuccess(message) {
    if (notFoundForm) notFoundForm.hidden = true;
    if (candidatesMain) candidatesMain.hidden = true;
    if (candidatesBack) candidatesBack.hidden = true;
    if (notFoundSuccess) {
      notFoundSuccess.hidden = false;
      const msgEl = notFoundSuccess.querySelector("[data-not-found-success-msg]");
      if (msgEl && message) msgEl.textContent = message;
    }
    const hint = $("[data-candidates-hint]");
    if (hint) hint.hidden = true;
  }

  function updateNotFoundFileLabel(file) {
    const nameEl = $("[data-nf-file-name]");
    const preview = $("[data-nf-image-preview]");
    if (nfImagePreviewUrl) {
      URL.revokeObjectURL(nfImagePreviewUrl);
      nfImagePreviewUrl = null;
    }
    if (!file) {
      if (nameEl) nameEl.textContent = "Aucun fichier";
      if (preview) {
        preview.hidden = true;
        preview.innerHTML = "";
      }
      return;
    }
    if (nameEl) nameEl.textContent = file.name;
    if (preview) {
      nfImagePreviewUrl = URL.createObjectURL(file);
      preview.innerHTML = `<img src="${nfImagePreviewUrl}" alt="Aperçu" loading="lazy" />`;
      preview.hidden = false;
    }
  }

  function formatDiscoverPrice(eur) {
    const n = parseFloat(eur);
    if (!Number.isFinite(n)) return "—";
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(n);
  }

  function formatOfferPrice(eur) {
    return formatDiscoverPrice(eur);
  }

  function discoverSectionVisible(sectionId, filter) {
    if (filter === "all") return true;
    if (filter === "single") {
      return sectionId === "singles" || sectionId === "spotlight";
    }
    if (filter === "booster_pack" || filter === "booster_box" || filter === "boosters") {
      return sectionId === "boosters";
    }
    if (filter === "display") return sectionId === "displays";
    if (filter === "graded") return sectionId === "graded";
    return true;
  }

  function isSealedCardNumber(num) {
    return /^(BOX|PACK|DISPLAY|DECK|1PACK|DSP)$/i.test(String(num || "").trim());
  }

  function countVisibleDiscoverCards(filter) {
    let n = 0;
    root.querySelectorAll("[data-discover-section]").forEach((block) => {
      const id = block.dataset.discoverSection || "";
      if (filter !== "all" && !discoverSectionVisible(id, filter)) return;
      n += block.querySelectorAll(".pk-so-discover__card").length;
    });
    return n;
  }

  function filterDiscoverSections() {
    root.querySelectorAll("[data-discover-section]").forEach((block) => {
      const id = block.dataset.discoverSection || "";
      const match =
        activeDiscoverFilter === "all" ||
        discoverSectionVisible(id, activeDiscoverFilter);
      block.hidden = false;
      block.classList.toggle(
        "pk-so-discover__section--dimmed",
        activeDiscoverFilter !== "all" && !match,
      );
    });

    const filterEmpty = $("[data-discover-filter-empty]");
    const globalEmpty = $("[data-discover-empty]");
    if (filterEmpty) {
      const visible = countVisibleDiscoverCards(activeDiscoverFilter);
      const showFilterMsg =
        activeDiscoverFilter !== "all" && visible === 0 && globalEmpty?.hidden;
      filterEmpty.hidden = !showFilterMsg;
      if (showFilterMsg) {
        const labels = {
          display: "display scellé",
          booster_pack: "booster (1 pack)",
          booster_box: "boîte scellée",
          graded: "carte gradée",
          single: "carte single",
        };
        filterEmpty.textContent = `Aucun ${labels[activeDiscoverFilter] || "produit"} dans les suggestions pour le moment. Renseignez le formulaire ci-dessous (ex. M2A · BOX) ou choisissez « Tout » pour tout parcourir.`;
      }
    }
  }

  function updateSearchHintForFilter(filter) {
    const hint = $("[data-search-hint]");
    if (!hint) return;
    const hints = {
      all: 'Exemples : série <strong>M2A</strong> · numéro <strong>242</strong> · ou <strong>S10A</strong> · <strong>077</strong>',
      single:
        "Recherche d’une <strong>carte single</strong> — code série et numéro obligatoires.",
      display:
        'Pour un <strong>display</strong> (carton Snkrdunk ディスプレイ), numéro <strong>DISPLAY</strong> (ex. SV5A · DISPLAY).',
      booster_pack:
        'Pour <strong>1 booster</strong> (1パック), numéro <strong>PACK</strong> (ex. SV5A · PACK).',
      booster_box:
        'Pour une <strong>boîte</strong> (拡張パック ボックス), numéro <strong>BOX</strong> (ex. M2A · BOX).',
      graded:
        "Carte <strong>gradée</strong> : indiquez série et numéro ; précisez PSA/ARS dans le nom si besoin.",
    };
    hint.innerHTML = hints[filter] || hints.all;
  }

  function setActiveCategoryButton(catId) {
    root.querySelectorAll("[data-search-cat]").forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.searchCat === catId);
      btn.setAttribute(
        "aria-pressed",
        btn.dataset.searchCat === catId ? "true" : "false",
      );
    });
  }

  function buildDiscoverCardElement(item) {
    const li = document.createElement("li");
    li.className = "pk-so-discover__card";
    const img = item.imageUrl
      ? `<img src="${escapeHtml(item.imageUrl)}" alt="" loading="lazy" width="140" height="196"/>`
      : `<span class="pk-so-discover__card-placeholder" aria-hidden="true">TCG</span>`;
    const isSealed = item.productType === "sealed";
    const sealedLabel =
      (item.sealedKind && SEALED_KIND_LABELS[item.sealedKind]) ||
      item.conditionHint ||
      "Scellé";
    const grade = isSealed
      ? `<span class="pk-so-discover__card-grade pk-so-discover__card-grade--display">${escapeHtml(sealedLabel)}</span>`
      : item.conditionHint
        ? `<span class="pk-so-discover__card-grade">${escapeHtml(item.conditionHint)}</span>`
        : "";
    const refLine = isSealed
      ? `${escapeHtml(item.setCode)} · ${escapeHtml(item.cardNumber)}`
      : `${escapeHtml(item.setCode)} · #${escapeHtml(item.cardNumber)}`;

    li.innerHTML = `
      <button type="button" class="pk-so-discover__card-btn" data-discover-pick>
        <span class="pk-so-discover__card-media">${img}</span>
        ${grade}
        <span class="pk-so-discover__card-ref">${refLine}</span>
        <span class="pk-so-discover__card-price">à partir de ${escapeHtml(formatDiscoverPrice(item.fromPriceEUR))}</span>
        <span class="pk-so-discover__card-cta">Voir les offres</span>
      </button>
    `;
    li.querySelector("[data-discover-pick]")?.addEventListener("click", () => {
      pickDiscoverItem(item);
    });
    return li;
  }

  function appendDiscoverItems(track, items) {
    items.forEach((item) => {
      track.appendChild(buildDiscoverCardElement(item));
    });
  }

  function renderDiscover(items) {
    const track = $("[data-discover-track]");
    const empty = $("[data-discover-empty]");
    if (!track) return;
    track.innerHTML = "";
    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    appendDiscoverItems(track, items);
  }

  function renderDiscoverSections(sections) {
    const container = $("[data-discover-sections]");
    const legacyWrap = $("[data-discover-legacy]");
    const empty = $("[data-discover-empty]");
    if (!container) return;

    container.innerHTML = "";
    const total = (sections || []).reduce(
      (n, s) => n + (s.items?.length || 0),
      0,
    );
    if (!total) {
      if (empty) empty.hidden = false;
      container.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    container.hidden = false;
    if (legacyWrap) legacyWrap.hidden = true;

    for (const sec of sections) {
      if (!sec.items?.length) continue;
      const block = document.createElement("article");
      block.className = "pk-so-discover__section";
      block.dataset.discoverSection = sec.id;

      const sub = sec.subtitle
        ? `<p class="pk-so-discover__section-lead">${escapeHtml(sec.subtitle)}</p>`
        : "";
      block.innerHTML = `
        <header class="pk-so-discover__section-head">
          <h4 class="pk-so-discover__section-title">${escapeHtml(sec.title)}</h4>
          ${sub}
        </header>
        <div class="pk-so-discover__track-wrap">
          <ul class="pk-so-discover__track" role="list"></ul>
        </div>
      `;
      const track = block.querySelector(".pk-so-discover__track");
      if (track) appendDiscoverItems(track, sec.items);
      container.appendChild(block);
    }
    filterDiscoverSections();
  }

  function applySearchCategory(cat) {
    if (!cat) return;
    setActiveCategoryButton(cat.id);

    if (cat.kind === "series" && cat.setCode && cat.cardNumber) {
      const searchForm = $("[data-search-form]");
      if (!searchForm) return;
      const setEl = searchForm.querySelector('[name="setCode"]');
      const numEl = searchForm.querySelector('[name="cardNumber"]');
      const titleEl = searchForm.querySelector('[name="title"]');
      if (setEl) setEl.value = cat.setCode;
      if (numEl) numEl.value = cat.cardNumber;
      if (titleEl) titleEl.value = "";
      activeDiscoverFilter = "all";
      filterDiscoverSections();
      updateSearchHintForFilter("all");
      showError("");
      handleSearch();
      return;
    }

    if (cat.filter) {
      activeDiscoverFilter = cat.filter;
      filterDiscoverSections();
      updateSearchHintForFilter(cat.filter);
      const searchForm = $("[data-search-form]");
      if (!searchForm) return;
      const numEl = searchForm.querySelector('[name="cardNumber"]');
      const titleEl = searchForm.querySelector('[name="title"]');
      if (cat.cardNumber && numEl) {
        numEl.value = cat.cardNumber;
      }
      if (cat.filter === "graded" && titleEl) {
        titleEl.placeholder = "PSA10, ARS10, BGS… (optionnel)";
      }
      const sectionMap = {
        display: "displays",
        booster_pack: "boosters",
        booster_box: "boosters",
        graded: "graded",
        single: "singles",
      };
      const target = root.querySelector(
        `[data-discover-section="${sectionMap[cat.filter] || "singles"}"]`,
      );
      target?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  function renderSearchCategories(categories) {
    const wrap = $("[data-search-categories]");
    const filtersRow = $("[data-search-cats-filters]");
    const seriesRow = $("[data-search-cats-series]");
    if (!wrap || !filtersRow || !seriesRow) return;

    filtersRow.innerHTML = "";
    seriesRow.innerHTML = "";

    for (const cat of categories || []) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "pk-so-search-cats__btn";
      btn.dataset.searchCat = cat.id;
      btn.textContent = cat.label;
      btn.setAttribute("aria-pressed", cat.id === "all" ? "true" : "false");
      if (cat.id === "all") btn.classList.add("is-active");
      btn.addEventListener("click", () => applySearchCategory(cat));

      if (cat.kind === "series") {
        btn.classList.add("pk-so-search-cats__btn--series");
        seriesRow.appendChild(btn);
      } else {
        filtersRow.appendChild(btn);
      }
    }

    const hasSeries = seriesRow.children.length > 0;
    const seriesLabel = wrap.querySelector(".pk-so-search-cats__label--series");
    if (seriesLabel) seriesLabel.hidden = !hasSeries;
    seriesRow.hidden = !hasSeries;
    wrap.hidden = !categories?.length;
  }

  async function loadDiscover() {
    const section = $("[data-discover]");
    if (!section || root.dataset.discoverEnabled === "false") return;

    section.hidden = false;
    const loading = $("[data-discover-loading]");
    const empty = $("[data-discover-empty]");
    const sectionsEl = $("[data-discover-sections]");
    const legacyWrap = $("[data-discover-legacy]");
    const layout = root.dataset.discoverLayout || "home";

    if (loading) loading.hidden = false;
    if (empty) empty.hidden = true;

    try {
      const limit = Math.min(
        Math.max(parseInt(root.dataset.discoverLimit || "10", 10) || 10, 4),
        14,
      );

      if (layout === "legacy") {
        if (sectionsEl) sectionsEl.hidden = true;
        if (legacyWrap) legacyWrap.hidden = false;
        const feed = root.dataset.discoverFeed || "trending";
        const data = await api(
          `/discover?feed=${encodeURIComponent(feed)}&limit=${limit}`,
        );
        renderDiscover(data.items || []);
      } else {
        if (legacyWrap) legacyWrap.hidden = true;
        const data = await api(`/discover/home?sectionLimit=${limit}`);
        renderDiscoverSections(data.sections || []);
        renderSearchCategories(data.categories || []);
      }
    } catch {
      if (empty) empty.hidden = false;
      if (sectionsEl) sectionsEl.hidden = true;
    } finally {
      if (loading) loading.hidden = true;
    }
  }

  async function pickDiscoverItem(item) {
    const searchForm = $("[data-search-form]");
    if (!searchForm) return;
    const setEl = searchForm.querySelector('[name="setCode"]');
    const numEl = searchForm.querySelector('[name="cardNumber"]');
    const titleEl = searchForm.querySelector('[name="title"]');
    const isSealed = item.productType === "sealed";
    if (setEl) setEl.value = item.setCode || "";
    if (numEl) {
      numEl.value = isSealed
        ? item.cardNumber || "BOX"
        : item.cardNumber || "";
    }
    if (titleEl && item.title) {
      titleEl.value = String(item.title).slice(0, 200);
    }
    showError("");
    await handleSearch();
  }

  async function init() {
    if (!API_BASE) {
      showError(
        "URL API non configurée. Renseignez « URL API sourcing » dans les réglages de la section Shopify.",
      );
      return;
    }
    try {
      const status = await api("/status");
      shopifyCheckoutEnabled = status.shopifyCheckout !== false;
      root.dataset.shopifyCheckout = shopifyCheckoutEnabled ? "true" : "false";
      loadDiscover();
    } catch (err) {
      showError(
        (err instanceof Error ? err.message : null) ||
          "Le service de commande spéciale est temporairement indisponible.",
      );
    }
  }

  root.querySelectorAll("[data-back]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.getAttribute("data-back");
      if (target) showStep(target);
      showError("");
      if (target === "search" || target === "candidates") {
        setNotFoundFormVisible(false);
        if (notFoundSuccess) notFoundSuccess.hidden = true;
      }
    });
  });

  async function handleSearch() {
    if (confirmingCard || loadingMoreOffers) {
      showError("Attendez la fin du chargement des annonces avant de modifier la recherche.");
      return;
    }
    const searchForm = $("[data-search-form]");
    if (!searchForm) return;

    const setCode = String(
      searchForm.querySelector('[name="setCode"]')?.value || "",
    ).trim();
    const cardNumber = String(
      searchForm.querySelector('[name="cardNumber"]')?.value || "",
    ).trim();
    const title = String(
      searchForm.querySelector('[name="title"]')?.value || "",
    ).trim();
    const language = String(
      searchForm.querySelector('[name="language"]')?.value || "JP",
    ).trim();

    if (!setCode || !cardNumber) {
      showError("Indiquez le code série et le numéro de carte.");
      searchForm.querySelector('[name="setCode"]')?.focus();
      return;
    }

    showError("");
    const body = {
      setCode,
      cardNumber,
      title: title || undefined,
      language,
    };
    const submitBtn = searchForm.querySelector("[data-search-submit]");
    if (submitBtn) submitBtn.disabled = true;
    try {
      const data = await api("/search", {
        method: "POST",
        body: JSON.stringify(body),
      });
      requestId = data.requestId;
      requestToken = data.requestToken;
      selectedCardRef = {
        setCode: body.setCode,
        cardNumber: body.cardNumber,
        language: body.language,
      };
      const candidates = data.candidates || [];
      partialCandidateResults = data.partialResults === true;
      renderCandidates(candidates);
      showStep("candidates");
      if (!candidates.length) {
        setNotFoundFormVisible(true, "no_match");
        showError(
          "Aucune carte trouvée pour cette recherche. Complétez le formulaire ci-dessous avec une photo.",
        );
        return;
      }
      setNotFoundFormVisible(false);
    } catch (err) {
      showError(err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  const searchForm = $("[data-search-form]");
  searchForm?.addEventListener("submit", (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleSearch();
  });
  searchForm
    ?.querySelector("[data-search-submit]")
    ?.addEventListener("click", (e) => {
      e.preventDefault();
      handleSearch();
    });
  searchForm?.querySelectorAll("input, select").forEach((el) => {
    el.addEventListener("keydown", (e) => {
      if (e.key !== "Enter") return;
      e.preventDefault();
      handleSearch();
    });
  });

  function renderCandidates(list) {
    const ul = $("[data-candidates-list]");
    if (!ul) return;
    ul.innerHTML = "";
    setResultsNotice("[data-candidates-list]", partialCandidateResults
      ? "La source n’a pas renvoyé toutes les pages de recherche. Les variantes affichées sont vérifiées, mais la liste peut être partielle."
      : `${list.length} variante${list.length > 1 ? "s" : ""} trouvée${list.length > 1 ? "s" : ""}. Comparez le titre et l’image avant de choisir.`);
    list.forEach((c) => {
      const li = document.createElement("li");
      li.className = "pk-special-order__candidate";
      const title = c.titleFR || c.titleJP || `${c.setCode} ${c.cardNumber}`;
      const imgUrl = c.imageUrl || "";
      const refLine = isSealedCardNumber(c.cardNumber)
        ? `${escapeHtml(c.setCode)} · ${escapeHtml(c.cardNumber)}`
        : `${escapeHtml(c.setCode)} · #${escapeHtml(c.cardNumber)}`;
      li.innerHTML = `
        ${productThumbHtml(imgUrl, title, title)}
        <div class="pk-special-order__card-meta">
          <strong>${escapeHtml(title)}</strong>
          <p>${refLine}${c.rarity ? " · " + escapeHtml(c.rarity) : ""}</p>
          ${c.source === "snkr" && c.sourceProductId
            ? `<p>Référence Snkrdunk : ${escapeHtml(c.sourceProductId)}</p>` : ""}
          <button type="button" class="btn btn--primary-red btn--sm" data-confirm-card>C'est celle-ci</button>
        </div>
      `;
      li.querySelector("[data-confirm-card]")?.addEventListener("click", () => confirmCard(c));
      ul.appendChild(li);
    });
    bindZoomTriggers(ul);
  }

  async function confirmCard(card) {
    if (confirmingCard || loadingMoreOffers) return;
    confirmingCard = true;
    const nextCardRef = {
      setCode: card.setCode,
      cardNumber: card.cardNumber,
      titleJP: card.titleJP,
      titleFR: card.titleFR,
      imageUrl: card.imageUrl,
      rarity: card.rarity,
      language: card.language,
      source: card.source,
      sourceProductId: card.sourceProductId,
    };
    const candidateButtons = root.querySelectorAll("[data-confirm-card]");
    candidateButtons.forEach((button) => { button.disabled = true; });
    setResultsNotice("[data-candidates-list]", "Recherche des annonces pour cette variante…");
    showError("");
    try {
      const data = await api("/confirm", {
        method: "POST",
        body: JSON.stringify({ requestId, requestToken, cardRef: nextCardRef }),
      });
      // A different variant gets its own request. Previously selected basket
      // offers keep their original request ID and capability.
      requestId = data.requestId || requestId;
      requestToken = data.requestToken || requestToken;
      selectedCardRef = nextCardRef;
      allOffers = data.offers || [];
      partialOfferResults = data.partialResults === true;
      hasMoreOffers = data.hasMoreOffers === true;
      activeGradeFilter = "ALL";
      renderGradeFilters();
      renderOffers(getFilteredOffers(), data.noOffers);
      showStep("offers");
    } catch (err) {
      showError(err.message);
      setResultsNotice("[data-candidates-list]", "Les annonces n’ont pas pu être chargées. Vous pouvez réessayer votre choix.");
    } finally {
      confirmingCard = false;
      candidateButtons.forEach((button) => { button.disabled = false; });
    }
  }

  function setResultsNotice(selector, text) {
    const list = $(selector);
    if (!list) return;
    let notice = list.previousElementSibling;
    if (!notice?.hasAttribute("data-results-notice")) {
      notice = document.createElement("p");
      notice.className = "pk-special-order__hint";
      notice.setAttribute("data-results-notice", "");
      notice.setAttribute("role", "status");
      list.parentNode.insertBefore(notice, list);
    }
    notice.textContent = text;
    notice.hidden = !text;
  }

  function updateMoreOffersButton() {
    const list = $("[data-offers-list]");
    if (!list) return;
    let button = $("[data-load-more-offers]");
    if (!button) {
      button = document.createElement("button");
      button.type = "button";
      button.className = "btn btn--outline";
      button.setAttribute("data-load-more-offers", "");
      button.addEventListener("click", loadMoreOffers);
      list.insertAdjacentElement("afterend", button);
    }
    button.hidden = !hasMoreOffers;
    button.disabled = loadingMoreOffers;
    button.textContent = loadingMoreOffers
      ? "Chargement des annonces suivantes…" : "Charger les annonces suivantes";
  }

  async function loadMoreOffers() {
    if (loadingMoreOffers || confirmingCard || !hasMoreOffers) return;
    loadingMoreOffers = true;
    updateMoreOffersButton();
    showError("");
    const ownerId = requestId;
    try {
      const data = await api("/offers/more", {
        method: "POST",
        body: JSON.stringify({ requestId, requestToken }),
      });
      if (requestId !== ownerId) return;
      allOffers = data.offers || allOffers;
      hasMoreOffers = data.hasMoreOffers === true;
      partialOfferResults = data.partialResults === true;
      renderGradeFilters();
      renderOffers(getFilteredOffers(), !allOffers.length);
    } catch (err) {
      showError(err.message);
    } finally {
      loadingMoreOffers = false;
      updateMoreOffersButton();
    }
  }

  /** Affiche uniquement le grade FR (sans texte japonais ni doublon). */
  function formatOfferCondition(raw) {
    if (!raw) return "—";
    let c = String(raw).split("(")[0].trim();
    const psa = c.match(/PSA\s*\d+/i);
    if (psa) return psa[0].toUpperCase().replace(/\s+/g, "");
    const parts = c.split("—").map((s) => s.trim()).filter(Boolean);
    const grade = parts[0] || parts[parts.length - 1] || c;
    if (/^[A-D]$/i.test(grade)) return `Grade ${grade.toUpperCase()}`;
    return grade;
  }

  /** Clé de filtre alignée sur Snkrdunk (PSA10, A, B…). */
  function parseGradeFilterKey(offer) {
    const g = String(offer?.conditionGrade || "").trim().toUpperCase();
    if (g) {
      if (/^PSA\d+/.test(g)) return g.replace(/\s+/g, "");
      if (/^[A-D]$/.test(g)) return g;
      if (/^ARS\d+/.test(g)) return g;
      if (/^BGS/.test(g)) return g;
      if (g === "新品") return "新品";
      return g;
    }
    const label = formatOfferCondition(offer?.condition, offer);
    if (/^Grade ([A-D])$/i.test(label)) return label.replace(/^Grade /i, "").toUpperCase();
    if (/^PSA\d+/i.test(label)) return label.toUpperCase();
    if (/^ARS\d+/i.test(label)) return label.toUpperCase();
    if (/^BGS/i.test(label)) return label.toUpperCase();
    return "OTHER";
  }

  function gradeFilterLabel(key) {
    return GRADE_FILTER_LABELS[key] || key;
  }

  function getFilteredOffers() {
    if (activeGradeFilter === "ALL") return allOffers;
    return allOffers.filter((o) => parseGradeFilterKey(o) === activeGradeFilter);
  }

  function renderGradeFilters() {
    const wrap = $("[data-grade-filters]");
    const inner = $("[data-grade-filters-inner]");
    const emptyMsg = $("[data-grade-filter-empty]");
    if (!wrap || !inner) return;

    const isSealedSearch = isSealedCardNumber(selectedCardRef?.cardNumber);
    if (!allOffers.length || isSealedSearch) {
      wrap.hidden = true;
      return;
    }

    const counts = new Map();
    allOffers.forEach((o) => {
      const k = parseGradeFilterKey(o);
      counts.set(k, (counts.get(k) || 0) + 1);
    });

    const keys = ["ALL"];
    for (const k of GRADE_FILTER_ORDER) {
      if (k === "ALL") continue;
      if (counts.has(k)) keys.push(k);
    }
    for (const k of counts.keys()) {
      if (!keys.includes(k)) keys.push(k);
    }

    if (!keys.includes(activeGradeFilter)) activeGradeFilter = "ALL";

    inner.innerHTML = keys
      .map((key) => {
        const n = key === "ALL" ? allOffers.length : counts.get(key) || 0;
        const active = key === activeGradeFilter ? " is-active" : "";
        const tabSelected = active ? ' aria-selected="true"' : ' aria-selected="false"';
        return `<button type="button" class="pk-grade-filter${active}" data-grade-filter="${escapeHtml(key)}" role="tab"${tabSelected}>
          <span class="pk-grade-filter__label">${escapeHtml(gradeFilterLabel(key))}</span>
          <span class="pk-grade-filter__count">${n}</span>
        </button>`;
      })
      .join("");

    wrap.hidden = false;

    inner.querySelectorAll("[data-grade-filter]").forEach((btn) => {
      btn.addEventListener("click", () => {
        activeGradeFilter = btn.getAttribute("data-grade-filter") || "ALL";
        renderGradeFilters();
        renderOffers(getFilteredOffers(), false);
        if (emptyMsg) {
          emptyMsg.hidden = getFilteredOffers().length > 0;
        }
      });
    });
  }

  function renderOffers(offers, noOffers) {
    const ul = $("[data-offers-list]");
    const manual = $("[data-no-offers]");
    if (!ul) return;
    ul.innerHTML = "";
    const countText = `${offers.length} annonce${offers.length > 1 ? "s" : ""} affichée${offers.length > 1 ? "s" : ""} sur ${allOffers.length} récupérée${allOffers.length > 1 ? "s" : ""} pour cette variante.`;
    setResultsNotice("[data-offers-list]", countText + (hasMoreOffers
      ? " D’autres annonces sont disponibles : chargez les suivantes ci-dessous."
      : partialOfferResults ? " La source est partiellement disponible ; certaines annonces peuvent manquer." : ""));
    updateMoreOffersButton();
    const emptyFilter = $("[data-grade-filter-empty]");
    if (noOffers || !allOffers.length) {
      if (manual) manual.hidden = hasMoreOffers;
      if (emptyFilter) emptyFilter.hidden = true;
      return;
    }
    if (manual) manual.hidden = true;
    if (!offers.length) {
      if (emptyFilter) emptyFilter.hidden = false;
      return;
    }
    if (emptyFilter) emptyFilter.hidden = true;

    const fallbackImg = selectedCardRef?.imageUrl || "";
    const cardTitle =
      selectedCardRef?.titleFR ||
      selectedCardRef?.titleJP ||
      (selectedCardRef?.setCode
        ? `${selectedCardRef.setCode} #${selectedCardRef.cardNumber}`
        : "Carte");

    offers.forEach((o) => {
      const li = document.createElement("li");
      li.className = "pk-special-order__offer";
      li.dataset.offerId = String(o.id);
      const priceLabel = formatOfferPrice(o.finalPriceEUR);
      const conditionLabel = formatOfferCondition(o.condition, o);
      const images = normalizeImageUrls(o, fallbackImg);
      const offerTitle = (o.title || "").trim();
      const zoomTitle = offerTitle
        ? `${offerTitle} — ${conditionLabel}`
        : `${cardTitle} — ${conditionLabel}`;
      const days =
        o.estimatedDays != null && o.estimatedDays > 0
          ? `Livraison estimée : <strong>${escapeHtml(String(o.estimatedDays))} jours</strong>`
          : "";
      const titleLine = offerTitle
        ? `<p class="pk-special-order__offer-title">${escapeHtml(offerTitle)}</p>`
        : "";
      const sealedBadge = o.sealedKind
        ? `<span class="pk-special-order__offer-type">${escapeHtml(SEALED_KIND_LABELS[o.sealedKind] || o.sealedKind)}</span>`
        : "";
      li.innerHTML = `
        ${offerPhotosHtml(images, zoomTitle)}
        <div class="pk-special-order__offer-body">
          ${titleLine}
          ${sealedBadge}
          <p>État : <strong>${escapeHtml(conditionLabel)}</strong></p>
          ${days ? `<p class="pk-special-order__offer-meta">${days}</p>` : ""}
          <p class="pk-special-order__offer-final"><strong>${escapeHtml(priceLabel)}</strong> <span class="pk-special-order__offer-final-hint">tout compris</span></p>
          <div class="pk-special-order__offer-actions">
            <button type="button" class="btn btn--primary-red" data-checkout-offer>Commander cette offre</button>
            <button type="button" class="btn btn--outline" data-add-cart-offer>Regrouper avec d'autres offres</button>
          </div>
        </div>
      `;
      li.addEventListener("click", (e) => {
        if (e.target.closest("button")) return;
        ul.querySelectorAll(".pk-special-order__offer").forEach((el) =>
          el.classList.remove("is-selected"),
        );
        li.classList.add("is-selected");
        li.scrollIntoView({ behavior: "smooth", block: "nearest" });
      });
      li.querySelector("[data-checkout-offer]")?.addEventListener("click", (e) => {
        e.stopPropagation();
        checkout(o.id, e.currentTarget);
      });
      li.querySelector("[data-add-cart-offer]")?.addEventListener("click", (e) => {
        e.stopPropagation();
        addOfferToCart(o, e.currentTarget);
      });
      bindOfferPhotoControls(li);
      ul.appendChild(li);
    });
    if (offers.length === 1) {
      ul.querySelector(".pk-special-order__offer")?.classList.add("is-selected");
    }
    bindZoomTriggers(ul);
  }

  const basketKey = "pk-special-order-basket-v2";
  const pendingCheckoutKey = "pk-special-order-pending-checkout-v1";
  let specialBasket = [];
  let pendingCheckout = null;
  // Old baskets had only sequential IDs: they cannot establish ownership.
  try {
    const legacyBasket = JSON.parse(localStorage.getItem("pk-special-order-basket-v1") || "[]");
    if (Array.isArray(legacyBasket) && legacyBasket.length) {
      showError("Vos offres enregistrées avant la mise à jour doivent être recherchées à nouveau pour sécuriser le paiement. Aucun paiement déjà ouvert n'est affecté.");
      localStorage.removeItem("pk-special-order-basket-v1");
    }
  } catch { /* Storage may be disabled. */ }
  try {
    const stored = JSON.parse(localStorage.getItem(basketKey) || "[]");
    if (Array.isArray(stored)) specialBasket = stored.filter((item) =>
      Number.isInteger(item.requestId) && Number.isInteger(item.offerId) &&
      typeof item.requestToken === "string" && /^[a-f0-9]{64}$/.test(item.requestToken)
    ).slice(0, 20).map((item) => ({
      requestId: item.requestId, offerId: item.offerId, requestToken: item.requestToken,
      label: String(item.label || `Offre #${item.offerId}`).slice(0, 100),
    }));
  } catch { /* Panier local indisponible : la commande immédiate reste possible. */ }

  function saveBasket() {
    try { localStorage.setItem(basketKey, JSON.stringify(specialBasket)); } catch {}
  }

  function isSafeCheckoutUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === "https:" &&
        !url.username && !url.password &&
        (url.hostname === window.location.hostname || url.hostname.endsWith(".myshopify.com"));
    } catch {
      return false;
    }
  }

  try {
    const savedCheckout = JSON.parse(sessionStorage.getItem(pendingCheckoutKey) || "null");
    if (savedCheckout && isSafeCheckoutUrl(savedCheckout.checkoutUrl) &&
      ["ready", "cart-clearing", "cart-clear-failed", "cart-not-confirmed"].includes(savedCheckout.status)) {
      pendingCheckout = savedCheckout;
    }
  } catch { /* Storage may be disabled. */ }

  function rememberCheckout(checkoutUrl, status, cartSnapshot) {
    pendingCheckout = {
      checkoutUrl,
      status,
      cartLineCount: cartSnapshot?.cartLines.length || 0,
      cartItems: cartSnapshot?.cartItems || [],
    };
    try {
      sessionStorage.setItem(pendingCheckoutKey, JSON.stringify(pendingCheckout));
      return true;
    } catch {
      return false;
    }
  }

  function canRememberCheckout() {
    try {
      sessionStorage.setItem(`${pendingCheckoutKey}-check`, "1");
      sessionStorage.removeItem(`${pendingCheckoutKey}-check`);
      return true;
    } catch {
      return false;
    }
  }

  function presentPendingCheckout(message, showLink = true) {
    const link = $("[data-checkout-link]");
    if (link) {
      link.href = pendingCheckout?.checkoutUrl || "#";
      link.hidden = !showLink || !pendingCheckout;
      link.textContent = "Reprendre le paiement Shopify";
    }
    const msg = $("[data-checkout-msg]");
    if (msg) msg.textContent = message;
    showStep("checkout");
  }

  async function getNormalCartSnapshot() {
    const cartRoot = window.Shopify?.routes?.root || "/";
    let response;
    try {
      response = await fetch(`${cartRoot}cart.js`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store",
      });
    } catch {
      throw new Error("Impossible de vérifier le panier Shopify. Réessayez avant de lancer le paiement.");
    }
    if (!response.ok) {
      throw new Error(`Impossible de lire le panier Shopify (${response.status}).`);
    }

    let cart;
    try {
      cart = await response.json();
    } catch {
      throw new Error("Shopify a renvoyé un panier illisible. Votre panier reste intact.");
    }
    if (!cart || !Array.isArray(cart.items)) {
      throw new Error("Le contenu du panier Shopify est invalide. Votre panier reste intact.");
    }
    if (Number(cart.item_count || 0) > 0 && cart.items.length === 0) {
      throw new Error("Le panier Shopify n’a pas pu être vérifié. Votre panier reste intact.");
    }
    if ((Array.isArray(cart.cart_level_discount_applications) && cart.cart_level_discount_applications.length) ||
      (Array.isArray(cart.discount_applications) && cart.discount_applications.length)) {
      throw new Error("Votre panier utilise une remise qui ne peut pas encore être reportée sur une commande spéciale. Retirez-la ou passez deux paiements séparés.");
    }

    const quantities = new Map();
    for (const item of cart.items) {
      if (!item || typeof item !== "object") {
        throw new Error("Une ligne du panier Shopify est invalide. Votre panier reste intact.");
      }
      if (item.selling_plan_allocation || item.selling_plan) {
        throw new Error("Le panier contient un abonnement qui ne peut pas être regroupé avec une commande spéciale. Passez deux paiements séparés.");
      }
      if (item.properties && typeof item.properties === "object" && Object.keys(item.properties).length) {
        throw new Error("Un article contient des options personnalisées qui ne peuvent pas encore être reportées. Passez deux paiements séparés.");
      }
      if ((Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length) ||
        (Array.isArray(item.discounts) && item.discounts.length)) {
        throw new Error("Une remise sur un article du panier ne peut pas encore être reportée sur une commande spéciale. Retirez-la ou passez deux paiements séparés.");
      }

      const variantId = Number(item.variant_id ?? item.id);
      const quantity = Number(item.quantity);
      if (!Number.isSafeInteger(variantId) || variantId <= 0 ||
        !Number.isSafeInteger(quantity) || quantity <= 0 ||
        typeof item.key !== "string" || !item.key.trim()) {
        throw new Error("Une ligne du panier Shopify ne peut pas être vérifiée. Votre panier reste intact.");
      }
      quantities.set(variantId, (quantities.get(variantId) || 0) + quantity);
      if (!Number.isSafeInteger(quantities.get(variantId))) {
        throw new Error("La quantité du panier Shopify est invalide. Votre panier reste intact.");
      }
    }
    const itemCount = cart.items.reduce((total, item) => total + item.quantity, 0);
    if (!Number.isSafeInteger(cart.item_count) || !Number.isSafeInteger(itemCount) ||
      cart.item_count !== itemCount) {
      throw new Error("Le nombre d’articles du panier Shopify ne correspond pas à ses lignes. Votre panier reste intact.");
    }
    const lines = Array.from(quantities, ([variantId, quantity]) => ({ variantId, quantity }));
    if (lines.length > 20) {
      throw new Error("Le panier contient plus de 20 variantes distinctes. Réduisez-le ou passez deux paiements séparés.");
    }
    if (lines.some((line) => line.quantity > 20)) {
      throw new Error("La quantité maximale est de 20 exemplaires par variante pour une commande spéciale groupée.");
    }
    return {
      cartLines: lines,
      cartItems: cart.items.map((item) => ({
        key: item.key,
        variantId: Number(item.variant_id ?? item.id),
        quantity: Number(item.quantity),
      })),
    };
  }

  function confirmCartInclusion(cartLines) {
    if (!cartLines.length) {
      return window.confirm(
        "Aucun article n’a été détecté dans le panier de cette boutique et de ce navigateur. " +
        "Ce paiement contiendra uniquement les offres spéciales. " +
        "Si vous avez des articles en attente, annulez et ouvrez le panier boutique avant de réessayer. Continuer sans article boutique ?",
      );
    }
    const quantity = cartLines.reduce((total, line) => total + line.quantity, 0);
    return window.confirm(
      `Votre panier boutique contient ${quantity} article${quantity > 1 ? "s" : ""}. ` +
      "Ils seront ajoutés au même paiement Shopify et le panier boutique sera vidé après la création du devis. Continuer ?",
    );
  }

  function sameCartItems(left, right) {
    const normalize = (items) => items
      .map(({ key, variantId, quantity }) => ({ key, variantId, quantity }))
      .sort((a, b) => a.key.localeCompare(b.key));
    return JSON.stringify(normalize(left)) === JSON.stringify(normalize(right));
  }

  async function clearNormalCart(cartSnapshot) {
    const checkoutUrl = pendingCheckout?.checkoutUrl;
    const expectedItems = cartSnapshot.cartItems.map((item) => ({ ...item }));
    if (!rememberCheckout(checkoutUrl, "cart-clearing", cartSnapshot)) {
      throw new Error("Le statut de suppression du panier n’a pas pu être enregistré. Le panier n’a pas été modifié.");
    }
    const cartRoot = window.Shopify?.routes?.root || "/";
    while (expectedItems.length) {
      const current = await getNormalCartSnapshot();
      if (!sameCartItems(expectedItems, current.cartItems)) {
        throw new Error("Le panier a changé depuis la création du devis. Aucun nouvel article n’a été supprimé.");
      }
      const item = expectedItems[0];
      if (!current.cartItems.some((currentItem) =>
        currentItem.key === item.key &&
        currentItem.variantId === item.variantId &&
        currentItem.quantity === item.quantity
      )) {
        throw new Error("Une ligne du panier a changé. Aucun autre article n’a été supprimé.");
      }

      let response;
      try {
        response = await fetch(`${cartRoot}cart/change.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "same-origin",
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
      } catch {
        throw new Error("Shopify n’a pas confirmé la suppression de la ligne du panier.");
      }
      if (!response.ok) {
        throw new Error(`Shopify n’a pas confirmé la suppression de la ligne du panier (${response.status}).`);
      }
      expectedItems.shift();
    }

    const finalCart = await getNormalCartSnapshot();
    if (!sameCartItems(expectedItems, finalCart.cartItems)) {
      throw new Error("Le panier a changé pendant sa mise à jour. Aucun article supplémentaire n’a été supprimé.");
    }
    if (!rememberCheckout(checkoutUrl, "ready", cartSnapshot)) {
      throw new Error("Le lien de paiement existe, mais l’état final du panier n’a pas pu être enregistré.");
    }
  }

  function resumeExistingCheckout() {
    if (!pendingCheckout) return false;
    if (pendingCheckout.status === "cart-not-confirmed") {
      presentPendingCheckout(
        "Un devis a été créé, mais le serveur n’a pas confirmé que les articles de la boutique y figurent. Votre panier est conservé. Ne payez pas ce devis et ne relancez pas encore la commande.",
        false,
      );
      return true;
    }
    if (pendingCheckout.status === "cart-clearing") {
      presentPendingCheckout(
        "La page s’est interrompue pendant le retrait de certains articles déjà inclus dans ce devis. Vérifiez manuellement votre panier avant de reprendre le paiement; ne relancez pas la commande.",
      );
      return true;
    }
    if (pendingCheckout.status === "cart-clear-failed") {
      presentPendingCheckout(
        "Un devis existe déjà. Le panier de la boutique n’a pas pu être vidé : ne relancez pas la commande, au risque de créer un doublon. Vous pouvez reprendre le paiement ci-dessous après avoir vérifié le panier.",
      );
      return true;
    }
    presentPendingCheckout(
      "Votre dernier devis Shopify reste disponible ci-dessous. Vous pouvez le reprendre ou continuer à naviguer.",
    );
    return false;
  }

  function showCartBanner() {
    let banner = root.querySelector("[data-cart-banner]");
    if (!banner) {
      banner = document.createElement("div");
      banner.className = "pk-so-cart-banner";
      banner.setAttribute("data-cart-banner", "");
      const list = $("[data-offers-list]");
      list?.parentNode?.insertBefore(banner, list);
    }
    const plural = specialBasket.length > 1 ? "s" : "";
    banner.innerHTML = `
      <strong>${specialBasket.length} offre${plural} sélectionnée${plural} pour une commande spéciale groupée.</strong>
      Un seul paiement Shopify, sans création de produits dans le catalogue. Les articles simples du panier boutique seront inclus et ce panier sera vidé après la création du devis.
      <ul>${specialBasket.map((item) => `<li>${escapeHtml(item.label)}
        <button type="button" class="btn btn--outline btn--sm" data-basket-remove="${item.requestId}" aria-label="Retirer ${escapeHtml(item.label)}">Retirer</button>
      </li>`).join("")}</ul>
      <span class="pk-so-cart-banner__actions">
        <button type="button" class="btn btn--primary-red btn--sm" data-basket-pay>Payer ensemble avec le panier boutique</button>
        <button type="button" class="btn btn--outline btn--sm" data-cart-new-search>Chercher une autre carte</button>
        <button type="button" class="btn btn--outline btn--sm" data-basket-clear>Vider la sélection</button>
      </span>`;
    banner.hidden = specialBasket.length === 0;
    banner.querySelector("[data-basket-pay]")?.addEventListener("click", checkoutBasket);
    banner.querySelector("[data-basket-clear]")?.addEventListener("click", () => {
      specialBasket = [];
      saveBasket();
      showCartBanner();
    });
    banner.querySelectorAll("[data-basket-remove]").forEach((button) =>
      button.addEventListener("click", () => {
        specialBasket = specialBasket.filter((item) =>
          item.requestId !== Number(button.dataset.basketRemove)
        );
        saveBasket();
        showCartBanner();
      })
    );
    banner
      .querySelector("[data-cart-new-search]")
      ?.addEventListener("click", () => {
        showStep("search");
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      });
  }

  async function addOfferToCart(offer, btn) {
    if (!shopifyCheckoutEnabled) {
      showError(
        "Paiement Shopify non configuré sur ce serveur (preview locale). L'ajout au panier fonctionnera sur la boutique.",
      );
      return;
    }
    showError("");
    if (specialBasket.length >= 20 && !specialBasket.some((item) => item.requestId === requestId)) {
      showError("Une commande groupée est limitée à 20 offres.");
      return;
    }
    specialBasket = specialBasket.filter((item) => item.requestId !== requestId);
    specialBasket.push({
      requestId, requestToken, offerId: offer.id,
      label: selectedCardRef?.titleFR || selectedCardRef?.titleJP ||
        `${selectedCardRef?.setCode || "Carte"} ${selectedCardRef?.cardNumber || ""}`,
    });
    saveBasket();
    showCartBanner();
    if (btn) btn.textContent = "✓ Offre sélectionnée";
  }

  async function checkoutBasket() {
    if (!specialBasket.length) return;
    if (resumeExistingCheckout()) return;
    showError("");
    const button = root.querySelector("[data-basket-pay]");
    if (button) button.disabled = true;
    try {
      const email = String(window.Shopify?.customer?.email || prompt("Votre email pour la commande :") || "").trim();
      if (!email) return;
      const cartSnapshot = await getNormalCartSnapshot();
      const cartLines = cartSnapshot.cartLines;
      if (!canRememberCheckout()) {
        throw new Error("Le navigateur ne peut pas mémoriser le lien de paiement. Autorisez le stockage de session avant de lancer le checkout.");
      }
      if (!confirmCartInclusion(cartLines)) return;
      const data = await api("/grouped-checkout", {
        method: "POST",
        body: JSON.stringify({
          items: specialBasket.map(({ requestId, requestToken, offerId }) => ({ requestId, requestToken, offerId })),
          ...(cartLines.length ? { cartLines } : {}),
          customerEmail: email,
        }),
      });
      if (!data.checkoutUrl) throw new Error("Lien de paiement introuvable");
      if (!isSafeCheckoutUrl(data.checkoutUrl)) {
        throw new Error("Shopify a renvoyé un lien de paiement invalide. Votre panier boutique n’a pas été modifié.");
      }
      if (cartLines.length && Number(data.cartLineCount) !== cartLines.length) {
        rememberCheckout(data.checkoutUrl, "cart-not-confirmed", cartSnapshot);
        specialBasket = [];
        saveBasket();
        showCartBanner();
        resumeExistingCheckout();
        return;
      }

      const canResume = rememberCheckout(data.checkoutUrl, cartLines.length ? "cart-clearing" : "ready", cartSnapshot);
      specialBasket = [];
      saveBasket();
      showCartBanner();
      if (cartLines.length) {
        if (!canResume) {
          pendingCheckout.status = "cart-clear-failed";
          presentPendingCheckout(
            "Un devis a été créé, mais le lien n’a pas pu être conservé dans cette session. Votre panier n’a pas été vidé. Gardez cette page ouverte et ne relancez pas la commande.",
          );
          return;
        }
        try {
          await clearNormalCart(cartSnapshot);
        } catch {
          rememberCheckout(data.checkoutUrl, "cart-clear-failed", cartSnapshot);
          resumeExistingCheckout();
          return;
        }
      }
      if (!canResume) {
        presentPendingCheckout(
          "Le devis Shopify a été créé, mais votre navigateur ne peut pas mémoriser son lien. Gardez cette page ouverte et reprenez le paiement avec le bouton ci-dessous.",
        );
        return;
      }
      presentPendingCheckout(
        cartLines.length
          ? "Vos offres spéciales et vos articles de la boutique sont réunis dans un seul paiement Shopify. Le panier boutique a été vidé pour éviter un double achat."
          : "Vos offres sont regroupées dans un seul paiement Shopify.",
      );
      window.location.assign(data.checkoutUrl);
    } catch (err) {
      showError(err.message);
    } finally {
      if (button) button.disabled = false;
    }
  }
  if (specialBasket.length) showCartBanner();
  if (pendingCheckout) resumeExistingCheckout();

  async function checkout(offerId, button) {
    if (!shopifyCheckoutEnabled) {
      showError(
        "Paiement Shopify non configuré sur ce serveur (preview locale). Les offres et prix sont testables ; le checkout fonctionnera sur la boutique avec l’API Taskmaster + Shopify.",
      );
      return;
    }
    if (resumeExistingCheckout()) return;
    showError("");
    if (button) button.disabled = true;
    try {
      const email = String(window.Shopify?.customer?.email || prompt("Votre email pour la commande :") || "").trim();
      if (!email) return;
      const cartSnapshot = await getNormalCartSnapshot();
      const cartLines = cartSnapshot.cartLines;
      if (!canRememberCheckout()) {
        throw new Error("Le navigateur ne peut pas mémoriser le lien de paiement. Autorisez le stockage de session avant de lancer le checkout.");
      }
      if (!confirmCartInclusion(cartLines)) return;
      const data = cartLines.length
        ? await api("/grouped-checkout", {
            method: "POST",
            body: JSON.stringify({
              items: [{ requestId, requestToken, offerId }],
              cartLines,
              customerEmail: email,
            }),
          })
        : await api("/checkout", {
            method: "POST",
            body: JSON.stringify({ requestId, requestToken, offerId, customerEmail: email }),
          });
      if (!data.checkoutUrl) throw new Error("Lien de paiement introuvable");
      if (!isSafeCheckoutUrl(data.checkoutUrl)) {
        throw new Error("Shopify a renvoyé un lien de paiement invalide. Votre panier boutique n’a pas été modifié.");
      }
      if (cartLines.length && Number(data.cartLineCount) !== cartLines.length) {
        rememberCheckout(data.checkoutUrl, "cart-not-confirmed", cartSnapshot);
        resumeExistingCheckout();
        return;
      }
      const canResume = rememberCheckout(data.checkoutUrl, cartLines.length ? "cart-clearing" : "ready", cartSnapshot);
      if (cartLines.length) {
        if (!canResume) {
          pendingCheckout.status = "cart-clear-failed";
          presentPendingCheckout(
            "Un devis a été créé, mais le lien n’a pas pu être conservé dans cette session. Votre panier n’a pas été vidé. Gardez cette page ouverte et ne relancez pas la commande.",
          );
          return;
        }
        try {
          await clearNormalCart(cartSnapshot);
        } catch {
          rememberCheckout(data.checkoutUrl, "cart-clear-failed", cartSnapshot);
          resumeExistingCheckout();
          return;
        }
      }
      if (!canResume) {
        presentPendingCheckout(
          "Le devis Shopify a été créé, mais votre navigateur ne peut pas mémoriser son lien. Gardez cette page ouverte pour reprendre le paiement.",
        );
        return;
      }
      presentPendingCheckout(
        cartLines.length
          ? "Votre article et l’offre spéciale sont réunis dans un seul paiement Shopify. Le panier boutique a été vidé pour éviter un double achat."
          : "Vous allez être redirigé vers le paiement sécurisé Shopify pour finaliser votre commande spéciale.",
      );
      if (cartLines.length) window.location.assign(data.checkoutUrl);
      else window.open(data.checkoutUrl, "_blank");
    } catch (err) {
      showError(err.message);
    } finally {
      if (button) button.disabled = false;
    }
  }

  $("[data-show-not-found-form]")?.addEventListener("click", () => {
    setNotFoundFormVisible(true, "no_match");
  });

  $("[data-hide-not-found-form]")?.addEventListener("click", () => {
    setNotFoundFormVisible(false);
  });

  notFoundForm?.querySelectorAll('[name="nfProductType"]').forEach((el) => {
    el.addEventListener("change", syncNotFoundGradeField);
  });

  const nfImageInput = notFoundForm?.querySelector("[data-nf-image-input]");
  nfImageInput?.addEventListener("change", () => {
    const file = nfImageInput.files?.[0];
    if (file && file.size > 4 * 1024 * 1024) {
      showError("Image trop volumineuse (max 4 Mo).");
      nfImageInput.value = "";
      updateNotFoundFileLabel(null);
      return;
    }
    showError("");
    updateNotFoundFileLabel(file || null);
  });

  $("[data-nf-file-trigger]")?.addEventListener("click", (e) => {
    e.preventDefault();
    nfImageInput?.click();
  });

  notFoundForm?.addEventListener("submit", async (e) => {
    e.preventDefault();
    showError("");

    const setCode = String(
      notFoundForm.querySelector('[name="nfSetCode"]')?.value || "",
    ).trim();
    const cardNumber = String(
      notFoundForm.querySelector('[name="nfCardNumber"]')?.value || "",
    ).trim();
    const customerEmail = String(
      notFoundForm.querySelector('[name="nfCustomerEmail"]')?.value || "",
    ).trim();
    const customerName = String(
      notFoundForm.querySelector('[name="nfCustomerName"]')?.value || "",
    ).trim();
    const productType =
      notFoundForm.querySelector('[name="nfProductType"]:checked')?.value || "";
    const imageFile = nfImageInput?.files?.[0];

    if (!setCode || !cardNumber) {
      showError("Indiquez le code série et le numéro de carte.");
      return;
    }
    if (!customerEmail) {
      showError("Indiquez votre adresse email.");
      return;
    }
    if (!customerName) {
      showError("Indiquez votre nom.");
      return;
    }
    if (!productType) {
      showError("Choisissez le type de produit recherché.");
      return;
    }
    if (!imageFile) {
      showError("Ajoutez une photo de la carte recherchée.");
      return;
    }
    if (imageFile.size > 4 * 1024 * 1024) {
      showError("Image trop volumineuse (max 4 Mo).");
      return;
    }

    const payload = {
      setCode,
      cardNumber,
      title: String(notFoundForm.querySelector('[name="nfTitle"]')?.value || "").trim() || undefined,
      language: notFoundForm.querySelector('[name="nfLanguage"]')?.value || "JP",
      customerEmail,
      customerName,
      productType,
      urgency: notFoundForm.querySelector('[name="nfUrgency"]:checked')?.value || "normal",
      notFoundReason: notFoundForm.querySelector("[data-nf-reason]")?.value || "no_match",
    };
    if (requestId && requestToken) {
      payload.requestId = requestId;
      payload.requestToken = requestToken;
    }

    const desiredGrade = String(
      notFoundForm.querySelector('[name="nfDesiredGrade"]')?.value || "",
    ).trim();
    if (desiredGrade) payload.desiredGrade = desiredGrade;

    const maxBudget = String(
      notFoundForm.querySelector('[name="nfMaxBudget"]')?.value || "",
    ).trim();
    if (maxBudget) payload.maxBudgetEur = Number(maxBudget);

    const notes = String(
      notFoundForm.querySelector('[name="nfNotes"]')?.value || "",
    ).trim();
    if (notes) payload.notes = notes;

    const submitBtn = notFoundForm.querySelector("[data-not-found-submit]");
    if (submitBtn) submitBtn.disabled = true;
    try {
      const compressed = await compressImageForUpload(imageFile);
      const { base64, mime } = await readImageAsBase64(compressed);
      payload.customerImageBase64 = base64;
      payload.customerImageMime = mime;

      const data = await api("/manual-request", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      const ref = data.requestId ? `Référence #${data.requestId}` : "";
      const mailHint = customerEmail
        ? ` Un email de confirmation sera envoyé à ${customerEmail} si la messagerie serveur est configurée.`
        : "";
      showNotFoundSuccess(
        (data.message ||
          "Demande enregistrée. Notre équipe vous recontactera avec un devis personnalisé.") +
          (ref ? ` ${ref}.` : "") +
          mailHint,
      );
      notFoundForm.reset();
      updateNotFoundFileLabel(null);
    } catch (err) {
      showError(err.message);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  $("[data-manual-request]")?.addEventListener("click", () => {
    showStep("candidates");
    setNotFoundFormVisible(true, "no_offers");
    prefillNotFoundForm("no_offers");
  });

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  updateStepper("search");
  initLightbox();
  init();
})();
